import type { TFunction } from "i18next";
export const formatTimestamp = (timestamp?: { _seconds: number; _nanoseconds: number }): string => {
  if (!timestamp?._seconds) return "N/A";
  return new Date(timestamp._seconds * 1000).toLocaleString();
};

export const formatWeight = (weight?: number): string => {
  if (!weight) return "N/A";
  return `${weight} t`;
};

export const formatTrailerName = (trailer: {
  brand?: string;
  model?: string;
  year?: number;
  plate?: string;
}): string => {
  const parts = [trailer.brand, trailer.model, trailer.year, trailer.plate].filter(Boolean);
  return parts.join(" • ");
};

export const getTextColorByParameter = (parameter: string): string => {
  switch (parameter) {
    case "Refrigerado":
      return "text-blue-600";
    case "Utility":
      return "text-violet-600";
    default:
      return "text-gray-600";
  }
};

export const shouldShowMapLocation = (
  lastAddress?: {
    _seconds: number;
    _nanoseconds: number;
  }
): boolean => {
  if (!lastAddress) return false;

  const firebaseTimeMs =
    lastAddress._seconds * 1000 +
    lastAddress._nanoseconds / 1_000_000;

  const nowMs = Date.now();

  const diffMs = nowMs - firebaseTimeMs;

  const fiveMinutesMs = 5 * 60 * 1000;

  return diffMs <= fiveMinutesMs;
};

export const getTypeFormatter = (parameter: string, t: TFunction): string => {
  const type = parameter.toLowerCase();
  
  switch (type) {
    case "dry_van":
      return t("trailers.type.dry_van");
    case "refrigerated":
      return t("trailers.type.refrigerated");
    case "flatbed":
      return t("trailers.type.flatbed");
    case "tank":
      return t("trailers.type.tank");
    case "lowboy":
      return t("trailers.type.lowboy");
    case "container":
      return t("trailers.type.container");
    case "dump":
      return t("trailers.type.dump");
    case "car_carrier":
      return t("trailers.type.car_carrier");
    default:
      return parameter;
  }
};
